export enum SearchIncrementType {
    Value = 1,
    Percentage = 2
}
